/* @jsx h */
import { defineComponent, h } from "vue";

interface OrderCardFieldValueProps {
  label: string;
  value?: string | number | null;
}

export const OrderCardFieldValue = defineComponent<OrderCardFieldValueProps>({
  name: "FieldValue",
  props: ["label", "value"],
  setup(props) {
    return () => (
      <>
        <span class={"text-accent uppercase font-semibold"}>
          {props.label}:
        </span>
        <span class={"break-all"}>{props.value || "-"}</span>
      </>
    );
  },
});
